<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Copyright {{ today | date:'y'}} © Go Perform by <img style="width: 2%;" src="assets/images/logo/logo-cropped.png" />&nbsp;<a href="https://gosell.fr">Go Sell</a>  </p>
    </div>
  </div>
</div>